<template>
  <div class="view box grow" style="overflow-y: auto">
    <page-headers
        :header="'Signals'"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        documentation="page-signals"
        class="box"
    >
    </page-headers>
    <div class="full-height" v-loading="alertIntegrationAccountsReqStatus === 'loading'">
      <el-row
          type="flex"
          class="account-summary__row"
          :gutter="20"
          v-if="alertIntegrationAccountsReqStatus === 'saved'"
      >
        <el-col :span="4">
          <div class="display-inline-block">
            <span class="display-block title">ACCOUNTS</span>
            <span class="display-block count"
            >{{ alertIntegrationSummary.accountCount || 0 }}
              <i class="fal fa-exclamation-triangle" v-if="alertIntegrationSummary.unhealthyCount > 0"></i>
            </span>
            <el-dropdown placement="top-start" v-if="$allow('network', 'write')">
              <div class="drop-down-title">
                <span class="display-inline-block">add new</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'trendmicro' } }">
                    <a class="display-inline-block">Trend Micro</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'pan' } }">
                    <a class="display-inline-block">Palo Alto Networks</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'carbonblack' } }">
                    <a class="display-inline-block">VMWARE Carbon Black</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'snyk' } }">
                    <a class="display-inline-block">Snyk</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'guardduty' } }">
                    <a class="display-inline-block">AWS Guard Duty</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'awslb' } }">
                    <a class="display-inline-block">Elastic Load Balancing</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'rds' } }">
                    <a class="display-inline-block">AWS Relational Database Services</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'cloudtrail' } }">
                    <a class="display-inline-block">AWS CloudTrail</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'devo' } }">
                    <a class="display-inline-block">Devo</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                      :to="{ name: 'integration-workflow', params: { integrationType: 'cloudtrail_history' } }">
                    <a class="display-inline-block">CloudTrail Event History Data</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                      :to="{ name: 'integration-workflow', params: { integrationType: 'azurelog' } }">
                    <a class="display-inline-block">Azure Logs</a>
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
        <el-col :span="8">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block half-width">
            <span class="display-block title">Detections</span>
            <span class="display-block count">{{ alertIntegrationSummary.detectionsCount || 0 }}</span>
            <router-link :to="{ name: 'account-iocs', query: { accountKeys: accountKeys } }">
              <a class="display-inline-block">view detections</a>
            </router-link>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <span class="display-block title">Progressions</span>
            <span class="display-block count">{{ alertIntegrationSummary.progressionCount || 0 }}</span>
            <router-link :to="{ name: 'account-progressions', query: { accountKeys: accountKeys } }">
              <a class="display-inline-block">view progressions</a>
            </router-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="float-right info-buttons">
            <el-button class="help-button" size="small" style="background: white">
              <el-link @click="loadDocumentation('page-signals')" :underline="false">
                User Guide
              </el-link>
            </el-button>
            <el-dropdown v-if="$allow('network', 'write')">
              <span class="el-dropdown-link">
                <el-button class="add-button" size="small">
                  Add New
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'trendmicro' } }">
                    <a class="display-inline-block">Trend Micro</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'pan' } }">
                    <a class="display-inline-block">Palo Alto Networks</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'carbonblack' } }">
                    <a class="display-inline-block">VMWARE Carbon Black</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'snyk' } }">
                    <a class="display-inline-block">Snyk</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'guardduty' } }">
                    <a class="display-inline-block">AWS Guard Duty</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'awslb' } }">
                    <a class="display-inline-block">Elastic Load Balancing</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'rds' } }">
                    <a class="display-inline-block">AWS Relational Database Services</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'cloudtrail' } }">
                    <a class="display-inline-block">AWS CloudTrail</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'devo' } }">
                    <a class="display-inline-block">Devo</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                      :to="{ name: 'integration-workflow', params: { integrationType: 'cloudtrail_history' } }">
                    <a class="display-inline-block">CloudTrail Event History Data</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                      :to="{ name: 'integration-workflow', params: { integrationType: 'azurelog' } }">
                    <a class="display-inline-block">Azure Logs</a>
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>

      <div class="table-toolbar" v-if="alertIntegrationAccountsReqStatus === 'saved'">
        <table-toolbar
            v-if="apiCalled"
            :key="alertIntegrationAccounts.key"
            :search-properties="visibleHostsColumns"
            :total-search-properties="hostsColumns"
            :search-data="alertIntegrationAccounts"
            :initial-tags="alertIntegrationAccounts.searchTags"
            :active-filter-data="activeFiltersData"
            :reload-component="alertIntegrationAccounts.reloadToolbar"
            :disable-search-box="disableSearchBox"
            @update-querydata="updateTableQueryData"
            @refresh-tabledata="refreshTableData"
            @update-columns-data="modifyColumnsData"
            @add-searchtags="addSearchTags"
            @deactivate-filter="deactivateFilter"
        >
          <div slot="left-toolbar-tools" class="filter-button-group">
            <span v-if="filterList.length">
              <div
                  class="display-inline mr-18 relative-pos"
                  v-for="(btn, index) in filterList"
                  :key="index"
              >
                <el-input
                    ref="customFilterInput"
                    class="filter-input"
                    v-if="btn.editFlag"
                    placeholder="+Name"
                    v-model="btn.name"
                    @change.native.stop="handleFilterNameChange(btn)"
                    @keyup.native.enter="handleFilterNameChange(btn)"
                    @blur="handleFilterNameChange(btn)"
                ></el-input>
                <el-button
                    v-else
                    size="small"
                    round
                    :class="{ active: btn.active }"
                    :id="btn.id"
                    @click="changeState(btn)"
                >
                  {{ btn.name }}
                  <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                    <span>
                      <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                      <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                    </span>
                  </el-tooltip>
                </el-button>

                <span v-if="btn.errFlag" class="filter-name-validator">{{ filterErrMsg }}</span>
              </div>
            </span>
          </div>
        </table-toolbar>
      </div>

      <action-table-element
          class="integration-account-table"
          v-if="alertIntegrationAccountsReqStatus === 'saved' && apiCalled"
          ref="integrationTable"
          :actions="tableActions"
          :columns="visibleHostsColumns"
          :table-data="alertIntegrationAccounts"
          :height-offset="40"
          @update-record-count="recordCountHandler"
      ></action-table-element>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {alertAccountsMetaInfo} from '@/column-header/integration_accounts/alert-accounts.meta'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'

import {INTEGRATIONS_LIST_REQUEST} from '@/store/modules/integrations/integrations.type'
import {AWS_LB_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/aws-lb-integration.type'
import {CARBONBLACK_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/carbonblack-integration.type'
import {GUARDDUTY_SETTINGS_SET} from '@/store/modules/integrations/guardduty-settings.type'
import {KUBERNETES_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/kubernetes-integration.type'
import {PAN_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/pan-integration.type'
import {SNYK_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/snyk-integration.type'
import {TRENDMICRO_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/trendmicro-integration.type'
import {RDS_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/rds-integration.type'
import {CLOUDTRAIL_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/cloudtrail-integration.type'
import {
  HISTORICAL_CLOUDTRAIL_INTEGRATION_CONFIG_SET
} from '@/store/modules/integrations/historical-cloudtrail-integration.type'
import {AZURE_LOG_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/azure-log-integration.type'
import {DEVO_INTEGRATION_CONFIG_SET} from '@/store/modules/integrations/devo-integration.type'
import {
  INTEGRATION_ACCOUNTS_LIST_REQUEST,
  DELETE_INTEGRATION_ACCOUNTS_REQ,
  PAUSE_INTEGRATION_ACCOUNTS_REQ,
  ALERT_INTEGRATION_VIEW_PREFERENCES_REQ,
  SAVE_ALERT_INTEGRATION_VIEW_PREFERENCES
} from '@/store/modules/integration_accounts/integration-accounts.type'
import {PREFERENCE_STORE_REQ} from '@/store/modules/column-preference/column-preference.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'

export default {
  name: 'AlertIntegrationAccounts',
  mixins: [loadDocumentationMixin, customFilterMixin],
  data() {
    return {
      alertIntegrationColumnPrefs: {},
      tableName: 'Signals',
      breadcrumbs: [{title: 'Setup'}, {title: 'Signals'}],
      hostsColumns: alertAccountsMetaInfo.meta.columns,
      // visibleHostsColumns: alertAccountsMetaInfo.meta.columns,
      visibleHostsColumns: [],
      apiCalled: false,
      tableActions: [
        {
          name: 'edit',
          icon: 'c-icon el-icon-edit',
          tooltip: 'Edit Integration Account',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          hide: {
            name: 'type',
            values: ['CLOUDTRAIL_HISTORY']
          },
          actionHandler: selection => {
            this.editAccount(selection.row)
          }
        },
        {
          name: 'delete',
          icon: 'c-icon el-icon-delete',
          tooltip: 'Delete Integration Account',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          actionHandler: selection => {
            let vm = this
            this.$confirm(`This will delete ${selection.row.nickName}. Continue?`, 'Delete integration account', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              callback: function (action) {
                if (action === 'confirm') {
                  vm.deleteAccount(selection.row)
                } else if (action === 'cancel') {
                  vm.$message({
                    type: 'info',
                    message: `Operation canceled`
                  })
                }
              }
            })
          }
        },
        {
          name: 'pause',
          icon: 'c-icon far',
          tooltip: 'Enable/Pause Integration Account',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          hide: {
            name: 'type',
            values: ['CLOUDTRAIL_HISTORY']
          },
          actionHandler: selection => {
            let vm = this
            let pause = selection.row.enabled ? 'Pause' : 'Enable'
            this.$confirm(
              `This will ${pause.toLowerCase()} ${selection.row.nickName}. Continue?`,
              `${pause} integration account`,
              {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                callback: function (action) {
                  if (action === 'confirm') {
                    vm.pauseAccount(selection.row)
                  } else if (action === 'cancel') {
                    vm.$message({
                      type: 'info',
                      message: `Operation canceled`
                    })
                  }
                }
              }
            )
          }
        }
      ],
      tblId: 17
    }
  },
  methods: {
    gotoConfigure(type, edit, acKey) {
      let routename = 'integration-workflow'
      if (edit) {
        routename = 'edit-integration-workflow'
      }
      this.$router.push({
        name: routename,
        params: {integrationType: type.toLowerCase(), accountKey: acKey}
      })
    },
    updateTableQueryData() {
      if (this.$refs.integrationTable) {
        this.$refs.integrationTable.updateTableData()
      }
    },
    recordCountHandler() {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.alertIntegrationAccounts.key = !this.alertIntegrationAccounts.key
      this.alertIntegrationAccounts.reloadToolbar = false
    },
    modifyColumnsData(selectedColumns) {
      this.alertIntegrationColumnPrefs.userId = this.userProfile.id
      this.alertIntegrationColumnPrefs.tblName = this.tableName
      this.alertIntegrationColumnPrefs.preferedCols = selectedColumns.length === 0 ? NaN : selectedColumns
      this.alertIntegrationColumnPrefs.tblId = 17 // For Mapping with database tables

      this.visibleHostsColumns = this.alertIntegrationAccounts.updateVisibleColumns(this.hostsColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_ALERT_INTEGRATION_VIEW_PREFERENCES, this.alertIntegrationColumnPrefs).then(data => {
        // store preferences in vuex
        this.alertIntegrationColumnPrefs.preferedCols = this.visibleHostsColumns
        this.$store.dispatch(PREFERENCE_STORE_REQ, this.alertIntegrationColumnPrefs)
      })
    },
    callApi(tableMetaData) {
      this.$store.dispatch(INTEGRATIONS_LIST_REQUEST).then(integrations => {
        this.$store.dispatch(INTEGRATION_ACCOUNTS_LIST_REQUEST).then(agents => {
          this.apiCalled = true
          this.setTableMetaData(tableMetaData)
        })
      })
    },
    setTableMetaData(tableMetaData) {
      this.alertIntegrationAccounts.searchTags = tableMetaData.searchTags
      this.alertIntegrationAccounts.currentPage = tableMetaData.activePage
    },
    refreshTableData(tableMetaData) {
      this.apiCalled = false
      this.callApi(tableMetaData)
    },
    loadAlertIntegrationColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleHostsColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(ALERT_INTEGRATION_VIEW_PREFERENCES_REQ, this.userProfile.id).then(data => {
          this.visibleHostsColumns = this.hostsColumns.filter(col => {
            return this.alertIntegrationPreferences.includes(col.label)
          })
          this.updateStoreWithPrefs()
        })
      }
    },
    updateStoreWithPrefs() {
      this.alertIntegrationColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleHostsColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.alertIntegrationColumnPrefs)
    },
    editAccount(row) {
      let type = row.type.toLowerCase()
      switch (type) {
        case 'awslb':
        case 'alb':
          type = 'awslb'
          this.$store.dispatch(AWS_LB_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            nickName: row.config.nickName,
            bucket: row.config.bucket,
            prefix: row.config.prefix,
            roleArn: row.config.roleArn,
            region: row.config.region,
            active: row.enabled,
            status: row.status
          })
          break
        case 'carbonblack':
          this.$store.dispatch(CARBONBLACK_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            nickName: row.config.nickName,
            bucket: row.config.bucket,
            prefix: row.config.prefix,
            roleArn: row.config.roleArn,
            region: row.config.region,
            active: row.enabled,
            status: row.status
          })
          break
        case 'guardduty':
          this.$store.dispatch(GUARDDUTY_SETTINGS_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            status: row.status,
            nickName: row.config.nickName,
            roleArn: row.config.roleArn,
            prefix: row.config.prefix,
            region: row.config.region,
            bucket: row.config.bucket
          })
          break
        case 'kubernetes':
          this.$store.dispatch(KUBERNETES_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            active: row.enabled,
            status: row.status,
            key: row.config.key,
            nickName: row.config.nickName,
            roleArn: row.config.roleArn,
            scanFrequency: row.config.scanFrequency,
            region: row.config.region,
            cluster: row.config.cluster
          })
          break
        case 'pan':
          this.$store.dispatch(PAN_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            status: row.status,
            nickName: row.config.nickName,
            port: parseInt(row.config.port),
            ssl: row.config.ssl,
            caCert: row.config.caCert,
            ip: row.config.ip
          })
          break
        case 'snyk':
          this.$store.dispatch(SNYK_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            status: row.status,
            apiKey: row.config.apiKey,
            nickName: row.config.nickName,
            orgUuid: row.config.orgUuid,
            scanFrequency: row.config.scanFrequency
          })
          break
        case 'trendmicro':
          this.$store.dispatch(TRENDMICRO_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            status: row.status,
            nickName: row.config.nickName,
            port: parseInt(row.config.port),
            ssl: row.config.ssl,
            ip: row.config.ip
          })
          break
        case 'rds':
          type = 'rds'
          this.$store.dispatch(RDS_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            nickName: row.config.nickName,
            bucket: row.config.bucket,
            prefix: row.config.prefix,
            roleArn: row.config.roleArn,
            region: row.config.region,
            active: row.enabled,
            status: row.status
          })
          break
        case 'cloudtrail':
          type = 'cloudtrail'
          this.$store.dispatch(CLOUDTRAIL_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            nickName: row.config.nickName,
            roleArn: row.config.roleArn,
            externalId: row.config.externalId,
            sqsUrl: row.config.sqsUrl,
            sqsRegion: row.config.sqsRegion,
            s3Region: row.config.s3Region
          })
          break
        case 'devo':
          type = 'devo'
          this.$store.dispatch(DEVO_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            nickName: row.config.nickName,
            url: row.config.url,
            token: row.config.token,
            table: row.config.table,
            logType: row.config.logType
          })
          break
        case 'cloudtrail_history':
          type = 'cloudtrail_history'
          this.$store.dispatch(HISTORICAL_CLOUDTRAIL_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            nickName: row.config.nickName,
            roleArn: row.config.roleArn,
            bucket: row.config.bucket,
            prefix: row.config.prefix,
            region: row.config.region,
            window: row.config.window
          })
          break
        case 'azurelog':
          type = 'azurelog'
          this.$store.dispatch(AZURE_LOG_INTEGRATION_CONFIG_SET, {
            accountKey: row.accountKey,
            key: row.key,
            active: row.enabled,
            nickName: row.config.nickName,
            eventHubNamespaceEndpoint: row.config.eventHubNamespaceEndpoint,
            eventHubName: row.config.eventHubName,
            numPartitions: row.config.numPartitions,
            sharedAccessKeyName: row.config.sharedAccessKeyName,
            sharedAccessKey: row.config.sharedAccessKey
          })
          break
      }
      this.gotoConfigure(type, true, row.accountKey)
    },
    deleteAccount(row) {
      this.$store.dispatch(DELETE_INTEGRATION_ACCOUNTS_REQ, row.accountKey).then(agents => {
        setTimeout(() => {
          this.refreshTableData({
            activePage: this.alertIntegrationAccounts.currentPage,
            searchTags: this.alertIntegrationAccounts.searchTags
          })
        }, 500)
      })
    },
    pauseAccount(row) {
      this.$store
        .dispatch(PAUSE_INTEGRATION_ACCOUNTS_REQ, {
          integrationId: row.accountKey,
          action: row.enabled ? 'disable' : 'enable'
        })
        .then(agents => {
          setTimeout(() => {
            this.refreshTableData({
              activePage: this.alertIntegrationAccounts.currentPage,
              searchTags: this.alertIntegrationAccounts.searchTags
            })
          }, 500)
        })
    }
  },
  created() {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }

    if (!this.$_.isEmpty(this.$route.query.type)) {
      tableMetaData.searchTags.push(this.$route.query.type)
    }

    this.callApi(tableMetaData)
    this.loadAlertIntegrationColumnPreferences()
  },
  computed: {
    ...mapGetters([
      'alertIntegrationAccountsReqStatus',
      'alertIntegrationAccounts',
      'alertIntegrationSummary',
      'integrationListReqStatus',
      'alertIntegrationPreferences',
      'userProfile',
      'userPref'
    ]),
    accountKeys() {
      if (this.alertIntegrationAccounts.models) {
        return _.map(this.alertIntegrationAccounts.models, 'accountKey')
      }
      return []
    }
  },
  components: {
    PageHeaders,
    TableToolbar,
    BasicTableElement,
    ActionTableElement
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';
@import 'assets/styles/accounts_list.css';

.table-toolbar {
  .el-button:last-of-type {
    .c-icon {
      border-left: 1px solid var(--border-color);
      padding-left: 10px;
    }
  }
}

>>> .el-radio {
  margin: 10px;
  line-height: 20px;

  .el-radio__label {
    vertical-align: middle;

    i {
      vertical-align: middle;
    }
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.disabled {
  color: var(--tuna-400);
  cursor: not-allowed;

  .c-icon {
    color: var(--tuna-400);
  }
}

.el-button {
  background-color: var(--aluminum-800);
  color: white;
}

.drop-down-title {
  font-size: 11px;
  color: #1a90fa;
  font-weight: 600;
  cursor: pointer;
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 8%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/integration-accounts/AlertIntegrationAccounts.vue